import { Redirect, Stack } from "expo-router";
import { Platform } from "react-native";
import { HeaderButton } from "~/components/HeaderButton";
import { useSession } from "~/providers/SessionProvider";
import { useTheme } from "~/providers/ThemeProvider";

export const unstable_settings = {
    initialRouteName: "start",
};

export default function GuestLayout() {
    const { dark } = useTheme();
    const { logged_in } = useSession();

    if (logged_in) {
        return <Redirect href="/dashboard" />;
    }

    return (
        <Stack
            screenOptions={{
                headerTransparent: true,
                headerLeft: () => <HeaderButton href="/start" title="Back" icon="chevron-left" />,
                title: "",
                statusBarStyle: Platform.select({ android: dark ? "light" : "dark", default: undefined }),
            }}
        />
    );
}
